import { render, staticRenderFns } from "./Recomendation.vue?vue&type=template&id=067bac91&"
import script from "./Recomendation.vue?vue&type=script&lang=js&"
export * from "./Recomendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports